import { TState } from '@r1-frontend/entities/stores/auth/reducer';

const selectAgreements = (state: TState) => {
    return state.auth.agreements.list;
};

export default selectAgreements;
